import { computed, ref, watchEffect, inject, provide } from 'vue'
import { useTemplate } from '../../../hooks/index'
import { BUTTONSHOW } from '../../../tokens/index'

const setMenuMap = (menus, map) => {
  for (const menu of menus) {
    map[menu.code] = true
    if (menu.children) {
      setMenuMap(menu.children, map)
    }
  }
  return map
}

/**
 * 配合useShow使用，用于判断所有按钮显示隐藏和节点下的所有子节点是否显示
 * @param {*} templateData
 * @param {*} menus
 * @returns
 */
export function useShowGroup(templateData, menus) {
  const menuMap = ref({})
  watchEffect(() => (menuMap.value = setMenuMap(menus.value, {})))
  provide(BUTTONSHOW, (key, val) => (menuMap.value[key] = val))

  const { getTemplateData, compileData } = useTemplate()
  const buttonGroupShow = (menu) => {
    let flag = true
    if (menu.showExp) {
      const compile = getTemplateData(null, templateData.value)
      flag = !!compileData(menu.showExp, compile)
    } else {
      flag = menu.children.some((im) => menuMap.value[im.code])
    }
    menuMap.value[menu.code] = flag
    return flag
  }

  const buttonAllShow = computed(() => menus.value.some((im) => menuMap.value[im.code]))

  return {
    buttonGroupShow,
    buttonAllShow,
  }
}

/**
 * 判断当前按钮是否显示
 * @param {*} templateData
 * @param {*} menu
 * @returns
 */
export function useShow(templateData, menu) {
  const setMenuShow = inject(BUTTONSHOW)
  const { getTemplateData, compileData } = useTemplate()
  const show = computed(() => {
    let flag = true
    if (menu.showExp) {
      const compile = getTemplateData(null, templateData.value)
      flag = !!compileData(menu.showExp, compile)
    }
    setMenuShow?.(menu.code, flag)
    return flag
  })

  return {
    show,
  }
}

/**
 * 获取表格行级按钮都是显示状态的列表
 * @param {*} templateData
 * @param {*} menus
 */
export function useShowGroupTable(templateData, menus) {
  provide(BUTTONSHOW, null)
  const { getTemplateData, compileData } = useTemplate()
  const compile = getTemplateData(null, templateData.value)
  const buttonList = computed(() => {
    return menus.value.reduce((pre, menu) => {
      const showExp = menu.showExp ? !!compileData(menu.showExp, compile) : true
      if (showExp) {
        pre.push({ ...menu, showExp: null })
      }
      return pre
    }, [])
  })

  return {
    buttonList,
  }
}
